import { createApp, markRaw, watch } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from '@/i18n';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import './style.css';

// 設定預設語系為 zh-TW，但允許切換
i18n.global.locale.value = 'zh-TW';
console.log('🔍 Main.ts: Setting default locale to zh-TW');

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import moment from 'moment';
import 'moment/dist/locale/zh-cn';
import 'moment/dist/locale/zh-tw';
import 'moment/dist/locale/en-gb';
import 'moment/dist/locale/ja';

import { VueQueryPlugin } from 'vue-query';

import { createPinia } from 'pinia';
const pinia = createPinia();
pinia.use(({ store }) => {
  store.router = markRaw(router);
});

import '@/scss/index.scss';
// import 'grid-layout-plus/dist/style.css'

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as labs from 'vuetify/labs/components'; // ✅ 加這行
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';

const vuetify = createVuetify({
  components: {
    ...components,
    ...labs // ✅ 加這行
  },
  directives,
  theme: {
    defaultTheme: 'dark',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        }
      },
      dark: {
        dark: true,
        colors: {
          primary: '#2196F3',
          secondary: '#424242',
          accent: '#FF4081',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          background: '#121212',
          surface: '#1E1E1E'
        }
      }
    }
  }
});

// 應用程式初始化
const initializeApp = async () => {
  // 設定預設語系，允許自由切換
  console.log('🔍 InitializeApp: Current locale:', i18n.global.locale.value);

  const app = createApp(App);

  // 添加全局錯誤處理
  app.config.errorHandler = (err, instance, info) => {
    console.error('Vue Error:', err);
    console.error('Component:', instance);
    console.error('Info:', info);
  };

  // 添加全局警告處理
  app.config.warnHandler = (msg, instance, trace) => {
    console.warn('Vue Warning:', msg);
    console.warn('Component:', instance);
    console.warn('Trace:', trace);
  };

  app
    .use(i18n)
    .use(VueQueryPlugin)
    .use(pinia)
    .use(vuetify)
    .use(router)
    .use(Vue3Toastify)
    .mount('#app');
};

// 啟動應用程式
initializeApp().catch((error) => {
  console.error('❌ Failed to initialize application:', error);
});
